define("settings/components/navigation-list", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--page__sidebarBody u--p__lr__0">
    <ul class="o--page__sidebarList">
      {{yield}}
    </ul>
  </div>
  */
  {
    "id": "JC3b7C05",
    "block": "[[[10,0],[14,0,\"o--page__sidebarBody u--p__lr__0\"],[12],[1,\"\\n  \"],[10,\"ul\"],[14,0,\"o--page__sidebarList\"],[12],[1,\"\\n    \"],[18,1,null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"&default\"],false,[\"yield\"]]",
    "moduleName": "settings/components/navigation-list.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});